<template>
  <div>
    <el-card style="margin-bottom: 20px;">
      <div slot="header" class="clearfix">
        <div class="pull-left text-lg height-30"><i class="ion-arrow-swap"></i> 设备控制</div>
        <div class="pull-right">
          <el-button type="success" class="box-inline ion-plus cur-pointer" size="small" title="选择设备" @click="$refs.selectClientDialog.showAddClient()"> 选择设备</el-button>
          <el-button class="box-inline ion-ios-upload-outline cur-pointer" size="small" title="加载命令" @click="showEditCommand"> 加载命令</el-button>
          <el-button class="box-inline ion-ios-download-outline cur-pointer" size="small" @click="showNewCommand"> 新增命令</el-button>
        </div>
      </div>
      <div class="clearfix">
        <el-row :gutter="10">
          <el-col :span="18" class="clearfix">
            <div style="width: 80px;color:#758697;font-weight: bold;" class="pull-left">
              命令主题
            </div>
            <div style="margin-left: 80px" class="mar-btm">
              <el-input v-model="form.topic" type="textarea" :autosize="{minRows: 1, maxRows: 10}"></el-input>
              <div class="mar-btm">
                {{`您选择的设备为：${(clientSn).join(', ')}`}}
              </div>
            </div>
          </el-col>
          <el-col :span="6" class="text-muted">
            默认命令主题为<code class="text-sm">设备编号/$cd</code><br/>可使用回车输入多个主题同时发送
          </el-col>
          <el-col :span="18">
            <div style="width: 80px;color:#758697;font-weight: bold;" class="pull-left">
              命令内容
            </div>
            <div style="margin-left: 80px;" class="mar-btm">
              <el-input v-model="form.payload" type="textarea" :autosize="{minRows: 3, maxRows: 10}"></el-input>
            </div>
          </el-col>
          <el-col :span="6" class="text-muted">
            建议使用JSON格式的命令，系统下发JSON命令时会插入<code class="text-sm">$cdsn</code>作为命令的唯一编号。
          </el-col>
          <el-col :span="18">
            <div style="width: 80px;color:#758697;font-weight: bold;" class="pull-left">
              命令质量
            </div>
            <div style="margin-left: 80px;" class="mar-btm">
              <el-radio v-model="form.qos" :label="0">QoS 0</el-radio>
              <el-radio v-model="form.qos" :label="1">QoS 1</el-radio>
              <el-radio v-model="form.qos" :label="2">QoS 2</el-radio>
            </div>
          </el-col>
          <el-col :span="6" class="text-muted">
          </el-col>
          <el-col :span="24">
            <div class="clearfix mar-btm text-center">
              <el-button type="primary" @click="send" class="ion-paper-airplane" :disabled="canSend"> 发 送</el-button>
              <el-button @click="clear" class="ion-trash-a"> 清 空</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card class="hover-color-change">
      <div slot="header" class="clearfix">
        <div class="pull-left text-lg height-30">
          <i class="ion-ios-recording"></i> 设备控制记录
          <el-button type="text" v-if="commandLogVisible" @click="getCommandLog" title="刷新记录历史"><i class="ion-ios-loop-strong"></i></el-button>
        </div>
      </div>
      <div v-if="commandLogVisible">
        <el-table :data="commandLogList" @cell-mouse-enter="hoverCell" :highlight-current-row="true" :row-key="row => row.id" :current-row-key="currentRowKey">
          <el-table-column label="命令主题" min-width="100">
            <template scope="scope">
              <div class="text-nowrap">
                {{scope.row.topic}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="内容" prop="payload"></el-table-column>
          <el-table-column label="类型" width="80">
            <template scope="scope">
              <div>
                {{scope.row.type === 'request' ? '命令' : '返回'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作人" prop="user.name" width="90">
          </el-table-column>
          <el-table-column label="时间" prop="updated_at" width="200"></el-table-column>
        </el-table>
        <div class="clearfix mar-top">
          <el-pagination class="pull-right"
            @current-change="changeLogPage"
            layout="total, prev, pager, next"
            :total="totalLogItem"
            :current-page="currentLogPage"
            :page-size="15">
          </el-pagination>
        </div>
      </div>
      <div v-else class="text-center text-lg text-muted mar-btm">
        仅在选择一个设备时显示其控制记录
      </div>
    </el-card>

    <el-dialog v-model="newCommandVisible" title="新增自定义命令" :close-on-click-modal="false" @close="cancelNewCommand">
      <el-form label-width="80px">
        <el-form-item label="命令名称">
          <div class="pos-rel">
            <i class="pos-abs" style="color: red;left: -81px;color: red;z-index: 99;top: 3px;">*</i>
            <el-input placeholder="命令名称" v-model="newCommand.name" class="mar-btm"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="命令内容" class="mar-no">
          <div class="pos-rel">
            <i class="pos-abs" style="color: red;left: -81px;color: red;z-index: 99;top: 3px;">*</i>
            <el-input type="textarea" v-model="newCommand.payload" class="mar-btm" placeholder="命令内容" :autosize="{minRows: 3, maxRows: 10}"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelNewCommand">取 消</el-button>
        <el-button type="primary" :disabled="canSave" @click="saveCommand">保 存</el-button>
      </span>
    </el-dialog>

    <select-client-dialog ref="selectClientDialog" @changeSelection="changeSelection"></select-client-dialog>

    <el-dialog title="加载自定义命令" v-model="editCommandVisible" :close-on-click-modal="false" @close="resetEditCommand" size="large">
      <div class="mar-btm text-right">
        <el-input style="width: 200px" v-model="commandQueryBind" placeholder="输入命令名称查询"></el-input>
        <el-button style="vertical-align:top" size="small" @click="queryCommandList"><i class="ion-search"></i></el-button>
      </div>
      <table class="table">
          <tr>
            <th style="width: 200px">命令名称</th>
            <th>命令内容</th>
            <th>操作</th>
          </tr>
        <tbody>
          <tr v-for="item in commandList">
            <td>
              <div v-show="item.id !== commandModifyIndex">
                {{item.name}}
              </div>
              <div v-show="item.id === commandModifyIndex">
                <el-input type="textarea" :autosize="{minRows: 3, maxRows: 10}" v-model="commandModifyForm.name">
                </el-input>
              </div>
            </td>
            <td>
              <div v-show="item.id !== commandModifyIndex">
                {{item.payload}}
              </div>
              <div v-show="item.id === commandModifyIndex">
                <div style="width:40px;float: right;padding-left:10px">
                  <i title="修改" style="color: #86c042;font-size: 25px;line-height:37px" class="cur-pointer ion-ios-checkmark" @click="modifyCommandItem"></i>
                  <i title="取消" style="color: #ee4a47;font-size: 25px;line-height:37px" class="cur-pointer ion-ios-close" @click="commandModifyIndex=-1"></i>
                </div>
                <div style="margin-right:50px">
                  <el-input  :ref="item.id" type="textarea" :autosize="{minRows: 3, maxRows: 10}" v-model="commandModifyForm.payload">
                  </el-input>
                </div>
              </div>
            </td>
            <td style="width:200px">
              <el-button size="small" type="primary" @click="editCommand('use', item.payload)">调用</el-button>
              <el-button size="small" @click="editCommand('edit', item)">编辑</el-button>
              <el-button size="small" type="danger" @click="editCommand('del', item.id)">删除</el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="clearfix mar-top">
        <el-pagination class="pull-right"
          @current-change="changeCommandPage"
          layout="total, prev, pager, next"
          :total="commandListTotal"
          :current-page="commandCurrentPage"
          :page-size="15">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<style>
  .noLabel .el-checkbox__label{
    display: none;
  }
  .hover-color-change .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #9df;
  }
  .hover-color-change .el-table__body tr.current-row > td {
    background-color: #9df;
  }
</style>
<script>
import { find as _find, isEqual as _isEqual } from 'lodash';
import SelectClientDialog from '@/components/SelectClientDialog';

export default {
  components: {
    SelectClientDialog,
  },
  mounted() {
    // 当从设备管理进入到该页面，获取相关信息
    if (this.$route.query.id) {
      this.form.topic = `${this.$route.query.sn}/$cd`;
      this.selection.push(parseInt(this.$route.query.id, 10));
      // this.$set(this.clientSn, this.$route.query.sn, this.$route.query.sn);
      this.clientSn.push(this.$route.query.sn);
    }
    // this.getClientList();
    this.getCommandList();
  },
  computed: {
    applicationId() {
      return this.$route.params.appId;
    },
    canSave() {
      return this.submitSaveDisable || !(this.newCommand.name.trim() && this.newCommand.payload.trim());
    },
  },
  data() {
    return {
      canSend: false,
      commandModifyForm: {
        name: '',
        payload: '',
      },
      commandModifyIndex: -1,
      commandList: [],
      commandListTotal: 0,
      commandCurrentPage: 1,
      // 自定义命令
      newCommand: { name: '', payload: '' },
      newCommandVisible: false,
      // 编辑命令对话框显隐
      editCommandVisible: false,
      // 单个设备的命令日志
      commandLogList: [],
      // 是否显示日志
      commandLogVisible: false,
      // 确定后的设备sn
      // clientSn: {},
      clientSn: [],
      // api参数
      form: {
        payload: '',
        topic: '',
        qos: 0,
      },
      // 确定后的选项
      selection: [],
      commandQuery: '',
      commandQueryBind: '',
      // 控制命令保存按钮的disable属性
      submitSaveDisable: false,
      // 设备控制记录高亮选中行的key值
      currentRowKey: null,
      // 设备控制记录总数
      totalLogItem: 0,
      // 设备控制记录当前页
      currentLogPage: 1,
      // 自动更新控制记录timer
      logTimer: null,
    };
  },
  watch: {
    selection() {
      // 如果监听到只选择一个设备，自动获取命令日志信息并展示，如果设备不止一个，则隐藏
      if (this.selection && this.selection.length === 1) {
        this.getCommandLog();
      } else if (this.commandLogVisible) {
        this.commandLogVisible = false;
      }
    },
  },
  methods: {
    doModifyCommandItem() {
      this.$axios.put(`command/${this.commandModifyIndex}`, {
        name: this.commandModifyForm.name,
        payload: this.commandModifyForm.payload.trim(),
      }).then(() => {
        this.$message({
          type: 'success',
          message: '成功修改命令',
          duration: 1500,
        });
        this.commandModifyIndex = -1;
        this.queryCommandList();
      }, (resp) => {
        this.$sys.alarmResponse(resp);
      });
    },
    modifyCommandItem() {
      if (this.commandModifyForm.name && this.commandModifyForm.payload) {
        const form = { ...this.commandModifyForm };
        form.payload = form.payload.trim();
        if (form.payload[0] === '{') {
          try {
            const string = form.payload.replace(/\n/g, '');
            JSON.parse(string);
            this.doModifyCommandItem();
          } catch (error) {
            this.$confirm('输入的命令内容非JSON格式, 是否继续发送?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.doModifyCommandItem();
            }).catch(() => {});
          }
        } else {
          this.doModifyCommandItem();
        }
      } else {
        this.$message({
          type: 'warning',
          message: '命令名称和内容必填',
          duration: 1500,
        });
      }
    },
    showEditCommand() {
      this.editCommandVisible = true;
      this.getCommandList();
    },
    delCommand(item) {
      this.$axios.delete(`command/${item}`).then(() => {
        this.$message({
          type: 'success',
          message: '成功删除该条命令',
          duration: 1500,
        });
        this.getCommandList();
      }, (resp) => {
        this.$sys.alarmResponse(resp);
      });
    },
    editCommand(method, item) {
      if (method === 'use') {
        this.form.payload = item;
        this.editCommandVisible = false;
      } if (method === 'del') {
        this.$confirm('此操作将删除该自定义命令, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.delCommand(item);
        }).catch(() => {
        });
      } else {
        this.commandModifyForm = { name: item.name, payload: item.payload };
        this.commandModifyIndex = item.id;
      }
    },
    resetEditCommand() {
      this.commandQuery = '';
      this.commandQueryBind = '';
    },
    queryCommandList() {
      this.commandQuery = this.commandQueryBind;
      if (this.commandCurrentPage !== 1) {
        this.commandCurrentPage = 1;
      } else {
        this.getCommandList();
      }
    },
    changeCommandPage(page) {
      this.commandCurrentPage = page;
      this.getCommandList();
    },
    getCommandList() {
      this.$axios.get('command', {
        params: {
          q: this.commandQuery,
          page: this.commandCurrentPage,
        },
      }).then((resp) => {
        this.commandList = resp.data.data;
        this.commandListTotal = resp.data.total;
      }, (resp) => {
        this.$sys.alarmResponse(resp);
      });
    },
    // 存保自定义命令
    doSaveCommand() {
      // 先将保存按钮diaable，发出请求后恢复
      this.submitSaveDisable = true;
      this.$axios.post('command',
        { name: this.newCommand.name.trim(), payload: this.newCommand.payload }).then(() => {
          this.$message({
            type: 'success',
            message: '成功保存自定义命令',
            duration: 1500,
          });
          this.newCommand = { name: '', payload: '' };
          this.newCommandVisible = false;
          this.queryCommandList();
          this.submitSaveDisable = false;
        }, (resp) => {
          this.submitSaveDisable = false;
          this.$sys.alarmResponse(resp);
        });
    },
    // 点击保存命令触发
    saveCommand() {
      this.form.payload = this.form.payload.trim();
      if (this.newCommand.name.trim() && this.newCommand.payload.trim()) {
        if (this.newCommand.payload[0] === '{') {
          try {
            const string = this.newCommand.payload.replace(/\n/g, '');
            JSON.parse(string);
            this.doSaveCommand();
          } catch (error) {
            this.$confirm('输入的命令内容非JSON格式, 是否继续发送?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.doSaveCommand();
            }).catch(() => {
            });
          }
        } else {
          this.doSaveCommand();
        }
      }
    },
    // 点击新增命令，展示自定义命令dialog
    showNewCommand() {
      this.newCommandVisible = true;
      this.newCommand.payload = this.form.payload;
    },
    // 关闭新增自定义命令dialog
    cancelNewCommand() {
      this.newCommandVisible = false;
      this.newCommand = { name: '', payload: '' };
    },
    // 获取命令日志
    getCommandLog() {
      this.$axios.get('command', {
        params: {
          where: {
            DciDeviceID: this.selection[0],
          },
          page: this.currentLogPage,
        },
      }).then((resp) => {
        if (!this.commandLogVisible) {
          this.commandLogVisible = true;
        }
        this.commandLogList = resp.data.data;
        this.totalLogItem = resp.data.total;
      }, (resp) => {
        this.$sys.alarmResponse(resp);
      });
    },
    send() {
      this.form.payload = this.form.payload.trim();
      // 如果没有选择设备，提示
      if (!this.selection || this.selection.length === 0) {
        this.$message({
          type: 'warning',
          message: '请至少选择一个设备',
          duration: 1500,
        });
        // 如果没有命令内容，提示
      } else if (!this.form.payload) {
        this.$message({
          type: 'warning',
          message: '命令内容必填',
          duration: 1500,
        });
        // 如果想输入JSON格式，且错误，提示
      } else if (this.form.payload[0] === '{') {
        try {
          const string = this.form.payload.replace(/\n/g, '');
          JSON.parse(string);
          this.command();
        } catch (error) {
          this.$confirm('输入的命令内容非JSON格式, 是否继续发送?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.command();
          });
        }
      } else {
        this.command();
      }
    },
    command() {
      this.canSend = true;
      this.$axios.post('command', {
        DciDeviceIDs: this.selection,
        Topic: this.form.topic.split('\n'),
        Payload: this.form.payload,
        Qos: this.form.qos,
      }).then(() => {
        this.canSend = false;
        this.$message({
          type: 'success',
          message: '成功发送命令',
          duration: 1500,
        });
        // 当单个设备时，更新日志
        if (this.selection.length === 1) {
          this.logTimer = window.setTimeout(() => {
            this.getCommandLog();
          }, 2500);
        }
      }, (resp) => {
        this.canSend = false;
        this.$sys.alarmResponse(resp);
      });
    },
    clear() {
      this.$refs.selectClientDialog.clear();
      this.form = {
        payload: '',
        topic: '',
        qos: 0,
      };
    },
    // 选择设备
    changeSelection(selections) {
      if (!_isEqual(this.selection, selections.map(item => item.id))) {
        this.form.topic = selections.map(item => `${this.applicationId}/${item.sn}/$cd`).join('\n');
        this.clientSn = selections.map(item => item.sn);
        this.selection = selections.map(item => item.id);
        this.currentLogPage = 1;
      }
    },
    // 设备控制记录table项hover时触发
    hoverCell(row) {
      if (row.type === 'response' && _find(this.commandLogList, { id: row.request_id })) {
        this.currentRowKey = row.request_id;
      } else {
        this.currentRowKey = row.id;
      }
    },
    // 翻页
    changeLogPage(page) {
      this.currentLogPage = page;
      this.getCommandLog();
    },
  },
  beforeDestroy() {
    window.clearTimeout(this.logTimer);
  },
};
</script>
